import { AbstractControl } from '@angular/forms';

export function ReceivingPersonValidator(control: AbstractControl): { [key: string]: boolean } | null {
  if (control && control.value) {
    if (control.value.existing && control.value.selectedName) {
      return null;
    }
    if (!control.value.existing && control.value.newName && control.value.newPhone) {
      return null;
    }
  }
  return { required: true };
}
